type Props = { url: string | null; name?: string | null; size?: number };

const COLORS = ["#7C3AED", "#F59E0B", "#2563EB", "#EF4444", "#059669", "#DB2777"];

export function Avatar({ url, name, size = 48 }: Props) {
  if (url) {
    return (
      <img
        src={url}
        alt=""
        className="rounded-full object-cover border-2 border-white shadow-[var(--shadow-card)]"
        style={{ width: size, height: size }}
      />
    );
  }
  const initial = (name ?? "?").trim().charAt(0).toUpperCase() || "?";
  const color = COLORS[initial.charCodeAt(0) % COLORS.length];
  return (
    <div
      className="rounded-full flex items-center justify-center text-white font-bold shadow-[var(--shadow-card)]"
      style={{
        width: size,
        height: size,
        background: color,
        fontSize: size * 0.4,
      }}
    >
      {initial}
    </div>
  );
}
